<template>
	<div id="app">
		<router-view/>
	</div>
</template>

<script>
	export default {
		name: 'app'
	}
</script>

<style>
	@import "./common/font/font.css";
	#app{
		font-family: "Delius Swash Caps", cursive;
	}
</style>
